import React from 'react'

import Button from '../../components/display/Button'

type EmptyBodyProps = {
  publicBucketlist?: boolean
}

export const EmptyBody = ({ publicBucketlist }: EmptyBodyProps) => {
  const heading = publicBucketlist
    ? 'This bucket list is empty'
    : 'Your bucket list is empty'

  return (
    <div className="bucketlist__empty">
      <div className="bucketlist__empty__heading-icon">
        <div className="riparide-icon" />
      </div>
      <div className="bucketlist__empty__heading">{heading}</div>
      {!publicBucketlist && (
        <>
          <div className="bucketlist__empty__cta-text">
            Let’s find some amazing places to fill your Bucket List.
          </div>
          <div className="bucketlist__empty__button">
            <a className="btn btn-lg btn-primary" href="/listings">
              Find Your Next Escape
            </a>
          </div>
        </>
      )}
    </div>
  )
}

type EmptyResultsProps = {
  onResetFilters?: (...args: any) => any
  type?: GQL_ListingTypes
  customHeading?: string | React.ReactNode
  customMessage?: string | React.ReactNode
}

export const EmptyResults = ({
  onResetFilters,
  type,
  customMessage,
  customHeading,
}: EmptyResultsProps) => {
  let targetDescriptionText
  switch (type) {
    case 'accommodation':
      targetDescriptionText = 'places to stay'
      break
    case 'adventures':
      targetDescriptionText = 'things to do'
      break
    default:
      targetDescriptionText = 'things'
      break
  }

  const heading =
    customHeading ??
    `None of the ${targetDescriptionText} in the bucket list match these filters`

  return (
    <div className="bucketlist__empty">
      <div className="bucketlist__empty__heading-icon">
        <div className="riparide-icon" />
      </div>
      <div
        className="bucketlist__empty__heading"
        style={{ paddingLeft: '16px', paddingRight: '16px' }}
      >
        {heading}
      </div>
      {customMessage && (
        <div
          className="bucketlist__empty__cta-text"
          style={{ paddingLeft: '16px', paddingRight: '16px' }}
        >
          {customMessage}
        </div>
      )}
      {onResetFilters && (
        <>
          <div className="bucketlist__empty__cta-text">
            Try changing or clearing the filters
          </div>
          <div className="bucketlist__empty__button">
            <Button onClick={onResetFilters}>Clear Filters</Button>
          </div>
        </>
      )}
    </div>
  )
}
